module.exports = __webpack_public_path__ + "img/gc_country_flag_ie.fb13395b.svg";